'use client';

import './basic-content-duo.scss';

import { useTranslation } from 'react-i18next';

import { cn } from '@sola/ark-core/utils/helpers.js';
import { FlexibleContentProps } from '@sola/schema/lib/schema.js';

import { Image } from '../../../atoms/image/image';
import { HeaderGroup } from '../../../molecules/header-group/header-group';
import {
  Lightbox,
  LightboxTrigger,
} from '../../../molecules/lightbox/lightbox';
import { getBaseSizeProps } from '../../../utils/text-utils';

export const BasicContentDuo: React.FC<FlexibleContentProps> = ({
  seoLevel = 2,
  media,
  quotation: _quotation,
  alt,
  inline,
  ...props
}) => {
  const { t } = useTranslation();

  const lightboxItems = [];
  const videoIndex = 0;
  if (media?.video) {
    lightboxItems.push({ media });
  }

  return (
    <section
      className={cn('BasicContentDuo component component--container', {
        'BasicContentDuo--alt': alt,
      })}
    >
      <div className="BasicContentDuo__container container">
        <div
          className={cn(
            'BasicContentDuo__flex flex flex-col gap-comfy-xl @lg:gap-roomy-sm',
          )}
        >
          <HeaderGroup
            {...props}
            {...getBaseSizeProps(seoLevel, inline)}
            seoLevel={seoLevel}
          />

          <div className={cn('BasicContentDuo__image')}>
            {lightboxItems.length > 0 && (
              <Lightbox items={[{ media }]} startIndex={videoIndex}>
                <LightboxTrigger
                  className="Lightbox__trigger w-full h-full"
                  ariaLabel={t('core.gallery.open')}
                >
                  <div className="FeatureCard__media w-full">
                    <Image
                      image={media?.image}
                      className={cn('BasicContentDuo__image-img')}
                      aspectRatio={alt ? '21-9' : '16-9'}
                      rounded="lg"
                      hasPlaceholder
                      isVideoThumbnail
                      videoDuration={media?.video?.duration}
                      priority={seoLevel === 1}
                      sizeIntent="full"
                    />
                  </div>
                </LightboxTrigger>
              </Lightbox>
            )}
            {lightboxItems.length === 0 && (
              <div className="FeatureCard__media w-full">
                <Image
                  image={media?.image}
                  className={cn('BasicContentDuo__image-img')}
                  aspectRatio={alt ? '21-9' : '16-9'}
                  rounded="lg"
                  hasPlaceholder
                  priority={seoLevel === 1}
                  sizeIntent="full"
                />
              </div>
            )}
            {media?.caption && (
              <figcaption className="BasicContentDuo__attribution label label-lg mt-comfy-sm">
                {media.caption}
              </figcaption>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
